import { Box, CircularProgress, Typography } from "@mui/material";

/** Small inline "Loading…" hint for compact bucket views. */
export const InlineLoading = () => (
  <Box display="flex" alignItems="center" gap={1}>
    <CircularProgress size={14} />
    <Typography variant="body2" color="text.disabled">
      Loading…
    </Typography>
  </Box>
);
